import useId from '../utils/useId';
import * as React from 'react';
export const ousdSvg = React.forwardRef(function ousdSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_ousd__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#390922',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z',
        fill: '#390922',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm26.414 8.672-2.946-.982a.563.563 0 0 1-.356-.358l-.983-2.946A.564.564 0 0 0 21.594 4H10.407a.564.564 0 0 0-.536.386L8.89 7.332a.567.567 0 0 1-.358.358l-2.946.982a.564.564 0 0 0-.386.535v13.588c0 .243.156.458.386.535l2.945.982a.566.566 0 0 1 .358.356l.982 2.946c.077.23.292.386.536.386h11.187a.564.564 0 0 0 .535-.386l.984-2.947a.563.563 0 0 1 .357-.357l2.945-.98a.565.565 0 0 0 .386-.536V9.206a.565.565 0 0 0-.386-.535v.001Z',
        fill: '#F3E9E3',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M20.505 17.117a3.448 3.448 0 0 0-1.098-1.275c-.487-.35-1.099-.661-1.838-.932l-1.828-.646c-.64-.21-1.13-.487-1.468-.832-.34-.344-.508-.781-.508-1.31 0-.407.101-.764.305-1.071.203-.308.49-.547.859-.72a2.88 2.88 0 0 1 1.237-.258c.764 0 1.404.264 1.921.793.518.53.887 1.25 1.109 2.161l.184.018 1.145-1.81A3.735 3.735 0 0 0 19.36 10.1a6.057 6.057 0 0 0-1.551-.692 6.013 6.013 0 0 0-1.275-.227V7.06h-.923v2.126a5.924 5.924 0 0 0-1.303.238c-.56.173-1.046.42-1.459.74-.413.32-.726.704-.942 1.153-.215.45-.323.946-.323 1.487 0 .58.126 1.093.379 1.543.251.449.615.837 1.089 1.163.473.327 1.067.632 1.782.915l1.662.572c.713.247 1.249.576 1.606.988.358.413.536.932.536 1.56 0 .494-.118.918-.351 1.275a2.362 2.362 0 0 1-.942.831c-.395.198-.85.296-1.366.296a3.195 3.195 0 0 1-1.496-.37c-.468-.246-.862-.624-1.182-1.135-.32-.511-.573-1.155-.757-1.93h-.185l-1.237 1.902a4.06 4.06 0 0 0 1.145 1.293 5.51 5.51 0 0 0 1.69.849 6.603 6.603 0 0 0 1.652.286v2.115h.924V22.83a6.352 6.352 0 0 0 1.404-.256 4.532 4.532 0 0 0 1.56-.813 3.753 3.753 0 0 0 1.016-1.274c.24-.493.36-1.04.36-1.644 0-.653-.123-1.228-.369-1.727Z',
        fill: '#390922',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_ousd__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          d: 'M0 0h32v32H0z',
        }),
      ),
    ),
  );
});
ousdSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var ousd = {
  category: 'brand',
  colorable: false,
  name: 'ousd',
  svg: ousdSvg,
};
